import { toLocale } from '@/utils/calculate.util';
import { getLocaleWordContent } from '@/utils/language.util';
import React, { useEffect } from 'react';
export default function Form({
    user,
    qty,
    pin,
    fee,
    fee_calc,
    calc,
    setQty,
    setCalc,
    setFee,
    setPin,
    handleChange,
    SendActions,
}) {
    const fetchBusinesses = () => {
        setFee(Number(qty) * (fee / 100));
        setCalc(Number(qty) - Number(qty) * (fee / 100));
    };
    useEffect(fetchBusinesses, [qty]);

    const sendBuy = (e) => {
        if (e) e.preventDefault();
        const params = { amount: qty, pin: pin };
        if (qty.length < 0 || pin.length < 1) {
            alert('Please fill in the box completely !');
        } else {
            SendActions.postWith(params).then((rsp) => {
                if (rsp === 1) {
                    alert(getLocaleWordContent('출금요청완료입니다'));
                    setQty('');
                    setFee('');
                    setCalc('');
                    setPin('');
                } else if (rsp === -93) {
                    alert(getLocaleWordContent('상품구매예약 취소 후 출금 가능합니다.'));
                } else {
                    alert(rsp.msg);
                }
            });
        }
    };
    return (
        <form className="inputbox">
            <div className="input_form">
                <p className="title">{getLocaleWordContent('출금 잔액')}</p>
                <div className="input_form01">
                    <input
                        type="text"
                        value={toLocale(user.getIn(['assets', 'POINT', 'rest'])) || ''}
                        className="input01"
                        required
                        readOnly
                    />
                    <span>{getLocaleWordContent('원')}</span>
                </div>
            </div>
            <div className="input_form">
                <p className="title">{getLocaleWordContent('출금요청금액')}</p>
                <div className="input_form01">
                    <input
                        type="text"
                        value={toLocale(qty)}
                        onChange={(e) => handleChange(e, 'qty')}
                        className="input01"
                        required
                    />
                    <span>{getLocaleWordContent('원')}</span>
                </div>
            </div>
            <div className="input_form">
                <p className="title">{getLocaleWordContent('수수료')}({fee || ''}%)</p>
                <div className="input_form01">
                    <input type="text" value={toLocale(fee_calc) || ''} className="input01" required readOnly />
                    <span>{getLocaleWordContent('원')}</span>
                </div>
            </div>
            <div className="input_form">
                <p className="title">{getLocaleWordContent('최종출금금액')}</p>
                <div className="input_form01">
                    <input type="text" value={toLocale(calc) || ''} className="input01" required readOnly />
                    <span>{getLocaleWordContent('원')}</span>
                </div>
            </div>
            <div className="input_form">
                <p className="title">{getLocaleWordContent('핀번호')}</p>
                <div className="input_form01">
                    <input
                        type="text"
                        value={pin}
                        onChange={(e) => handleChange(e, 'pin')}
                        className="input01"
                        required
                    />
                </div>
            </div>
            <div className="sub_btn_box">
                <input type="button" defaultValue={getLocaleWordContent('요청하기')} className="btn01" onClick={sendBuy} />
            </div>
        </form>
    );
}
